export class CreateConveyanceSegmentRequest {
  ConveyanceID: number;
  SegmentName: String;
  Ordinal: number;
  ActionID: number;
}
